const oneTimeListener = (node, type, callback, runningOnBlur) => {
  node.addEventListener(type, function listener(e) {
    // remove event listener
    if (runningOnBlur) {
      !isCurrentTabActive() && e.target.removeEventListener(e.type, listener);
    } else {
      isCurrentTabActive() && e.target.removeEventListener(e.type, listener);
    }
    // call handler with original context
    return callback.call(this, e);
  });
};

// to check if tab is active or not, returns boolean
export const isCurrentTabActive = (
  onTabChangeFn = null,
  isRunOnlyOnce = false,
  runningOnBlur = false
) => {
  let stateKey = undefined;
  let eventKey = undefined;

  let keys = {
    hidden: "visibilitychange",
    webkitHidden: "webkitvisibilitychange",
    mozHidden: "mozvisibilitychange",
    msHidden: "msvisibilitychange",
  };

  for (stateKey in keys) {
    if (stateKey in document) {
      eventKey = keys[stateKey];
      break;
    }
  }

  // keep !eventKey
  if (!eventKey) {
    window.onfocus = function () {
      if (onTabChangeFn) onTabChangeFn(true);
      if (isRunOnlyOnce) {
        window.onfocus = null;
      }
      return true;
    };

    window.onblur = function () {
      if (onTabChangeFn) onTabChangeFn(false);
      if (isRunOnlyOnce) {
        window.onblur = null;
      }
      return false;
    };

    return !document.hidden;
  } else {
    if (isRunOnlyOnce) {
      if (onTabChangeFn) {
        oneTimeListener(document, eventKey, onTabChangeFn, runningOnBlur);
      }
    } else {
      if (onTabChangeFn) document.addEventListener(eventKey, onTabChangeFn);
    }

    return !document[stateKey];
  }
};

// fn to run fn when tab gets focused
export const onTabFocus = (
  fn = null,
  isRunOnlyOnce = false,
  isRunOnInit = false
) => {
  if (!fn) {
    return;
  } else {
    if (isRunOnInit && isCurrentTabActive()) {
      fn();
    }
    isCurrentTabActive((isVisible = null) => {
      let visibility = false;
      if (typeof isVisible === "object") {
        visibility = isCurrentTabActive();
      } else {
        visibility = isVisible;
      }
      visibility && fn();
    }, isRunOnlyOnce);
  }
};

// fn to run fn when tab gets blured
export const onTabBlur = (
  fn = null,
  isRunOnlyOnce = false,
  isRunOnInit = false
) => {
  if (!fn) {
    return;
  } else {
    if (isRunOnInit && !isCurrentTabActive()) {
      fn();
    }
    isCurrentTabActive(
      (isVisible = null) => {
        let visibility = false;
        if (typeof isVisible === "object") {
          visibility = isCurrentTabActive();
        } else {
          visibility = isVisible;
        }
        !visibility && fn();
      },
      isRunOnlyOnce,
      true
    );
  }
};

export const onWindowLoad = (fn = null) => {
  if (!fn) {
    return;
  } else {
    if (document.readyState === "ready" || document.readyState === "complete") {
      fn();
    } else {
      document.onreadystatechange = function () {
        if (document.readyState == "complete") {
          fn();
        }
      };
    }
  }
};

export function preloadImages(array) {
  if (!preloadImages.list) {
    preloadImages.list = [];
  }
  var list = preloadImages.list;
  for (var i = 0; i < array.length; i++) {
    var img = new Image();
    img.onload = function () {
      var index = list.indexOf(this);
      if (index !== -1) {
        // remove image from the array once it's loaded
        // for memory consumption reasons
        list.splice(index, 1);
      }
    };
    list.push(img);
    img.src = array[i];
  }
}
